<template>
    <div>
        <div class="baojiatitle">
            <h3 color="primary">{{ zidian.guoBan }}</h3>

            <div v-if="false" style="margin-left: auto">
                <Button size="small" @click="addTable(danjiaModel)">新增表格</Button>
            </div>
        </div>
        <div id="itemList" v-for="(item, row) in itemData.list" :key="row">
            <div class="fenleibiaoti">
                <unitBoxDanjia :unit="item.list" :units="danjias" @on-change="unitChangeDanjia(item, $event)">
                </unitBoxDanjia>
                <Tag color="success">币别</Tag>
                <currency v-model="item.currency"></currency>
                <Tag color="blue">起步价</Tag>
                <InputNumber size="small" v-model="item.startPirce"></InputNumber>
                <Tag color="blue">起步价(进口)</Tag>
                <InputNumber size="small" v-model="item.startPirceIn"></InputNumber>
                <div v-if="false" style="margin-left: auto">
                    <Button size="small" @click='copyTable(item)'>复制表格</Button>
                    <Button size="small" @click="itemData.list.splice(row, 1)">删除表格</Button>
                </div>
            </div>
            <div class="priceTable">
                <div>
                    <p>
                        计价单位
                    </p>
                    <p>
                        收费
                    </p>
                </div>
                <div v-for="(x, col) in item.list" :key="col">
                    <p>
                        <Input readonly :border="false" size="small" v-model="x.unit[0]"></Input>
                    </p>
                    <p>
                        <Input :border="false" size="small" v-model="x.price"></Input>
                    </p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import hanshu from "../gongshi/hanshu.vue";
import modelData from "../baojia/modelData";
import currency from "../baojia/currency.vue";
import unitBoxDanjia from "../baojia/unitBoxDanjia.vue";
import startAddendAdd from "../baojia/startAddendAdd.vue";
export default {
    props: ["data",],
    components: { hanshu, unitBoxDanjia, currency, startAddendAdd },
    data() {
        return {
            zidian: modelData.zidian,
            itemData: {
                partPrice: {
                    "startPirce": 0,
                    "pl": 0,
                    "kgs": 0,
                    "cbm": 0,
                    "ctn": 0
                },
                list: [],
                startPirce: 0
            },
            units: ['ff', 'dd'],
            danjias: [
                {
                    name: "KGS",
                    select: true,
                },
                {
                    name: "CBM",
                    select: true,
                },
                {
                    name: "件",
                    select: true,
                },
                {
                    name: "P/L",
                    select: true,
                },
            ],
            gongshi: {
                1: "danjia(0,'份','人民币')",
                2: "huoZhi(0/10000,0,'港元')",
            },
            danjiaModel: modelData.danjiaModel
        };
    },
    methods: {
        tt() {
            this.itemData = this.data;
            //this.funTo();
        },
        getVal() {
            //this.toFun();
            return this.itemData;
        },
        unitChangeDanjia(item, abc) {
            console.log(777, item, abc);
            var list = item.list;
            var index = 0;
            for (let m = 0; m < list.length; m++) {
                if (abc.name == list[m].unit[0]) {
                    index = m;
                }
            }
            var select = abc.select;
            var name = abc.name;

            if (select) {
                //选中，添加回来
                list.push({
                    unit: [name],
                    function: this.gongshi[abc.bgCost],
                    price: 0,
                });
            } else {
                //取消选中。删除

                list.splice(index, 1);
            }
        },
        //添加表格
        addTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            //list.splice(index, 0, obj);
            this.itemData.list.unshift(JSON.parse(JSON.stringify(obj)));
        },
        copyTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            this.itemData.list.push(JSON.parse(JSON.stringify(obj)));
        },
        //转化成函数
        toFun() {
            var t = this.itemData.list;
            for (let i = 0; i < t.length; i++) {
                t[i].function = "danjiaPrice(" +
                    t[i].startPirce + "," +
                    t[i].startPirceIn + ")"

            }

        },
        //函数转化为字段
        funTo() {
            var t = this.itemData.list;
            for (let i = 0; i < t.length; i++) {
                var k = eval('this.' + t[i].function);

                t[i].startPirce = k.a;
                t[i].startPirceIn = k.b;
            }

        },
        danjiaPrice(a, b) {
            return { a, b }
        },
    },
    mounted() {
        this.tt();
    },
    watch: {
        data() {
            this.tt();
        }
    }


};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojias/guoBan.vue